module.exports = __webpack_public_path__ + "img/SFZbmzp.a02d24de.png";